import { parseCurrency } from '@/lib/utils'
import { z } from 'zod/v4'
import type { SavedPosCartFilters, SavedPosCartSearch } from './carts.types'

export const customCartItemSchema = z.object({
  name: z.string().trim().min(1, 'A name is required.'),
  description: z.string().optional(),
  notes: z.string().optional(),
  recipe: z.string().optional(),
  image: z
    .object({
      id: z.number(),
    })
    .loose()
    .nullable()
    .optional(),
  category_id: z.number().nullable().optional(),
  category_name: z.string().nullable().optional(),
  price: z
    .string()
    .trim()
    .min(1, 'A price is required.')
    .refine((value) => parseCurrency(value) > 0, 'Price must be greater than $0.00.'),
})

export const catalogCartItemDetailsSchema = z.object({
  notes: z.string().optional(),
  recipe: z.string().optional(),
  description: z.string().optional(),
})

export const savePosCartSchema = z.object({
  label: z.string().trim().max(120, 'Keep the label under 120 characters.'),
})

export const defaultSavedPosCartSearchParams = {
  page: 1,
  page_size: 20,
  payment: 'all',
} as const

export const savedPosCartSearchSchema = z.object({
  search: z.string().optional().catch(undefined),
  page: z.coerce.number().int().positive().catch(defaultSavedPosCartSearchParams.page),
  page_size: z.coerce
    .number()
    .int()
    .positive()
    .max(100)
    .catch(defaultSavedPosCartSearchParams.page_size),
  // "held" lists only drafts with customer money on them.
  payment: z.enum(['all', 'held']).catch(defaultSavedPosCartSearchParams.payment),
})

export function getSavedPosCartFilters(
  search: Partial<SavedPosCartSearch> = {}
): SavedPosCartFilters {
  const searchTerm = search.search?.trim()

  return {
    ...(searchTerm ? { search: searchTerm } : {}),
    ...(search.payment === 'held' ? { payment: 'held' } : {}),
  }
}
